import {
  createApp
} from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import http from "./http/api";
import VueAxios from "vue-axios";
import ElementPlus from "element-plus";
import "element-plus/lib/theme-chalk/index.css";

import { pageMixin } from "@/views/mixin/page.js";
// createApp(App).use(store).use(VueAxios, http).use(router).use(ElementPlus).use(dataV).mixin(pageMixin).component('box',
// 	box).mount(
// 	"#app");
createApp(App).use(store).use(VueAxios, http).use(router).use(ElementPlus).mixin(pageMixin).mount("#app");
router.beforeEach((to, from, next) => {
  // 获取用户登录成功后储存的登录标志和token
  let phone = localStorage.getItem("phone");
  let token = localStorage.getItem("token");

  // 如果有登录信息但Vuex状态未更新，则同步更新Vuex状态
  if (phone && token && !store.state.isLogin) {
    store.dispatch('login', {
      phone: phone,
      token: token
    });
  }

  // 判断用户是否已登录（结合localStorage和Vuex状态）
  const isLoggedIn = phone && token;

  // 如果已登录
  if (isLoggedIn) {
    // 如果已登录但想进入登录注册界面，则定向回首页
    if (to.path === '/login') {
      next({
        path: "/",
      });
    } else {
      next();
    }
    // 如果未登录
  } else {
    // 用户想进入需要登录的页面，则定向回登录界面
    if (to.meta.isLogin) {
      next({
        path: "/login",
      });
      //用户进入无需登录的界面，则跳转继续
    } else {
      next();
    }
  }
});
router.afterEach(() => {
  window.scroll(0, 0);
});